// extracted by mini-css-extract-plugin
module.exports = {"container":"PlaceholderModal_container__O9_UR","header":"PlaceholderModal_header__25u5a","content":"PlaceholderModal_content__2mp4i"};